import { useNavigate } from "react-router-dom";

import {
  ImagePromptCard,
  LoadingState,
  WaveBackgroundLayout,
} from "~/common/components";
import SuccessIcon from "~/common/components/layouts/SuccessIcon";
import { useGetCurrentTeamMember, useTeamMemberIsAuth } from "../hooks";
import { ROUTES } from "../router";
import { getHomeRouteByPermissions } from "../utils";

export const SuccessAuthScreen = () => {
  const navigate = useNavigate();
  const { data: isLoggedIn, isLoading } = useTeamMemberIsAuth();

  const { data: teamMember, isLoading: isLoadingTeamMember } =
    useGetCurrentTeamMember({
      enabled: !!isLoggedIn && !isLoading,
    });

  const handleNavigate = () => {
    if (isLoggedIn && teamMember)
      return navigate(getHomeRouteByPermissions(teamMember?.user_permissions));

    return navigate(ROUTES.login);
  };

  return (
    <WaveBackgroundLayout className="relative justify-center p-6">
      {isLoading || isLoadingTeamMember ? (
        <LoadingState />
      ) : (
        <ImagePromptCard
          title="Account created"
          subtitle="We recommend a desktop or tablet for optimal user experience."
          handleContinue={handleNavigate}
          imageContainerClassName="bg-green-100"
          continueLabel={isLoggedIn ? "Go to Home" : "Proceed to login"}
        >
          <SuccessIcon className="w-full" />
        </ImagePromptCard>
      )}
    </WaveBackgroundLayout>
  );
};
